import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getServicemenReviews,
    deleteReview,
} from "../redux/slices/reviewSlice";
import Swal from "sweetalert2";

const ServicemenReviews = ({ servicemenId }) => {
    const dispatch = useDispatch();

    const {
        servicemenReviews,
        totalReviews,
        averageRating,
        loading,
    } = useSelector((state) => state.reviews);

    useEffect(() => {
        if (servicemenId) {
            dispatch(getServicemenReviews(servicemenId));
        }
    }, [servicemenId, dispatch]);

    // ===============================
    // 🔥 DELETE REVIEW
    // ===============================
    const handleDelete = async (id) => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this review?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
        });

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReview(id));
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-body">

                    <h4 className="mb-3">Servicemen Reviews</h4>

                    <div className="d-flex justify-content-between mb-3">
                        <h5>Total Reviews: {totalReviews}</h5>
                        <h5>Average Rating: ⭐ {averageRating}</h5>
                    </div>

                    {/* ===============================
              LOADING
          =============================== */}
                    {loading && <p>Loading...</p>}

                    {/* ===============================
              TABLE
          =============================== */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover text-center">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>User</th>
                                    <th>Rating</th>
                                    <th>Comment</th>
                                    <th>Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {servicemenReviews && servicemenReviews.length > 0 ? (
                                    servicemenReviews.map((review, index) => (
                                        <tr key={review._id}>
                                            <td>{index + 1}</td>
                                            <td>{review?.userId?.name || "Unknown User"}</td>
                                            <td>⭐ {review.rating}</td>
                                            <td>{review.comment || "-"}</td>
                                            <td>{new Date(review.createdAt).toLocaleDateString()}</td>
                                            <td>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(review._id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No reviews found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ServicemenReviews;
